import React from 'react';
import Card from '../../../components/Card';
import { PageWrapper } from '../../styles';

import welcomeHSPAData from '../../../constants/pagesData/welcomeHSPAData';

const WelcomeHSPA = ({t}) => {
    return ( 
        <PageWrapper>
            <Card data={welcomeHSPAData} t={t}/>
        </PageWrapper>
    );
}
 
export default WelcomeHSPA;